// 施工管理(モックアップ準拠 area 中心)。純正2タブ(施工箇所 / 材料追跡)+ area 詳細・新規・編集ルート。
//   旧 ConstructionPlan ダッシュボード(plan_info 一覧)+ 在庫/数量計画タブは廃止し、
//   在庫/数量計画は独立ルート(/console/stock/, /console/quantity-plan/)へ移設(Pages.tsx)。
import { useState } from "react";
import { Stack, Typography, Paper, Tabs, Tab, Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { PageContext } from "../PageContext";
import AreaListPage from "./AreaListPage";
import MaterialTrackingPage from "./MaterialTrackingPage";
import AreaDetailPage from "./AreaDetailPage";
import AreaFormPage from "./AreaFormPage";

export default function ConstructionPlanPage({ pageContext }: { pageContext: PageContext }) {
  return (
    <Routes>
      <Route index element={<ConstructionPlanLanding pageContext={pageContext} />} />
      <Route path="area/new/" element={<AreaFormPage pageContext={pageContext} mode="new" />} />
      <Route path="area/:areaId/" element={<AreaDetailPage pageContext={pageContext} />} />
      <Route path="area/:areaId/edit/" element={<AreaFormPage pageContext={pageContext} mode="edit" />} />
    </Routes>
  );
}

function ConstructionPlanLanding({ pageContext }: { pageContext: PageContext }) {
  const [tab, setTab] = useState(0);
  return (
    <Stack p={3} gap={2} maxWidth={1400} mx="auto">
      <Typography variant="h4" fontWeight="bold">施工管理</Typography>
      <Paper variant="outlined">
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tab label="施工箇所" />
          <Tab label="材料追跡" />
        </Tabs>
      </Paper>
      <Box>
        {tab === 0 && <AreaListPage pageContext={pageContext} />}
        {tab === 1 && <MaterialTrackingPage pageContext={pageContext} />}
      </Box>
    </Stack>
  );
}
